import Slice9Panel from "../../../../../shared/lib/html5-software-library/src/ranj/components/scale9/Slice9Panel";
import AbstractView from "../../../../../shared/src/ranj/equalture/view/AbstractView";

export default class FeedbackPanelView extends AbstractView {

    constructor(target) {
        super(target);

        this._textField = this._target.bodyTextfield;
        // disable text wrapping
        this._textField.lineWidth = null;

        const bitmap = this._target.children.find(c => c instanceof createjs.Bitmap);
        this._slice9Panel = new Slice9Panel(this._target, bitmap, {
            cacheBitmap: true,
            mode: Slice9Panel.HORIZONTAL,
            overlap: false,
            pixelPerfect: true,
        });
        this._slice9Panel.update();

        this._origY = this._target.y;

        this.show(false);
    }

    show(isVisible) {
        this._target.visible = isVisible;
    }

    setText(text, disappear = false) {
        createjs.Tween.removeTweens(this._target);
        
        this.applyText(this._textField, text);
        this._slice9Panel.update();
        
        this._target.alpha = 1;
        this.show(true);

        if (disappear) {
            createjs.Tween.get(this._target, { override: true })
                .to({ y: this._origY + OFFSET, alpha: 0 }, 2000, createjs.Ease.sineIn)
                .call(() => {
                    this.show(false);
                    this.dispatchEvent(FeedbackPanelView.CLOSE);
                });
        }
    }
}

FeedbackPanelView.CLOSE = "FeedbackPanelView.CLOSE";

const OFFSET = -100;